import React, { useCallback, useRef } from 'react';
import cn from 'classnames';

import Button from 'components/form/Button.component';
import CurrencySign from 'components/price/CurrencySign.component';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import call from 'utils/functions/call.util';

import CN from './BalanceSheetLayoutSummary.module.scss';

const BalanceSheetLayoutSummary = ({ onToggle, value, open }) => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();
  const elementRef = useRef(null);

  const handleClick = useCallback(
    (ev) => call(`BalanceSheetLayoutSummary.onToggle`, onToggle, { ev, open, element: elementRef.current }),
    [onToggle, open],
  );

  return (
    <div
      data-bem="BalanceSheetLayoutSummary"
      data-open={fromAnyToString(fromAnyToBool(open))}
      className={cn({
        [CN.component]: true,
        [CN.open]: open,
        [CN.dark]: isDarkMode,
      })}
      ref={elementRef}
    >
      <div className={CN.clientName}>{value?.clientName}</div>
      <div className={CN.value}>
        <CurrencySign value={value?.cash} />
      </div>
      <div className={CN.value}>
        <CurrencySign value={value?.card} />
      </div>
      <div className={CN.value}>
        <CurrencySign value={value?.slick_pos} />
      </div>
      <div className={CN.value}>
        <CurrencySign value={value?.online} />
      </div>
      <div className={CN.value}>
        <CurrencySign value={value?.other} />
      </div>
      <div className={CN.value}>
        <CurrencySign value={value?.total} />
      </div>
      <div>
        <Button
          tag="BalanceSheetLayoutSummary__toggle-details"
          variant="slim"
          stripped
          onClick={handleClick}
          variantInvert={open}
        >
          <div className={CN.buttonText}>{open ? t('balanceSheet.hideButton') : t('balanceSheet.viewButton')}</div>
        </Button>
      </div>
    </div>
  );
};

export default BalanceSheetLayoutSummary;
